module.exports = __webpack_public_path__ + "static/media/seta_baixo.51121b61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/seta_baixo.svg
// module id = 2751
// module chunks = 0